const numericId = (value) => {
  const id = Number(value);
  return Number.isSafeInteger(id) ? id : null;
};

const silentMessageTypes = new Set(["automated", "user", "recipient"]);

export const isOwnTeamNotification = (notification, authUser) => {
  if (notification?.conversation_type !== "team") return false;

  const currentUser = authUser?.user || authUser;
  const senderId = numericId(notification?.sender_id);
  const currentUserId = numericId(currentUser?.user_id);

  if (senderId !== null && senderId === currentUserId) return true;

  const senderPersonalInboxId = numericId(
    notification?.sender_personal_inbox_id,
  );
  if (senderPersonalInboxId === null) return false;

  return (currentUser?.personal_inboxes || []).some(
    (personalInbox) =>
      numericId(personalInbox?.id ?? personalInbox?.personal_inbox_id) ===
      senderPersonalInboxId,
  );
};

export const shouldShowBrowserNotification = (notification, authUser) => {
  if (!notification) return false;

  const messageType = notification.message_type || notification.sender_type;
  if (silentMessageTypes.has(messageType)) return false;

  // Missing team/sender metadata must fail open. Showing an extra notification
  // during a rolling backend deployment is safer than hiding a teammate's
  // message because the payload contract was incomplete.
  return !isOwnTeamNotification(notification, authUser);
};
// A notification without a message id cannot be identified across renders, so
// it returns null and the caller falls back to firing. That matches the
// fail-open rule above: a duplicate is better than a swallowed message.
export const getNotificationKey = (notification) => {
  const messageId = notification?.message_id;
  return messageId === null || messageId === undefined
    ? null
    : `id:${String(messageId)}`;
};

// The display effect also depends on the authenticated user, which gets a new
// object identity mid-session (for example after a profile image upload).
// Without this guard that re-run would replay an old notification and its tone.
export const shouldFireNotification = (
  notification,
  authUser,
  lastHandledKey,
) => {
  if (!notification) return false;

  const key = getNotificationKey(notification);
  if (key !== null && key === lastHandledKey) return false;

  return shouldShowBrowserNotification(notification, authUser);
};
